import { useState, useEffect, useCallback } from "react";

import makeStyles from "styles/muiStylesCompat/makeStyles";
import { useParams } from "react-router-dom";

import Paper from "@mui/material/Paper";

import SpinnerCentered from "~/components/Loader/SpinnerCentered";
import { httpGetPreorder } from "~/services/http/preorders";
import OrderDetail from "~/components/OrderDetail";

const useStyles = makeStyles(() => ({
  content: {
    padding: 48,
    overflowX: "auto",
  },
}));

const PreorderDetailView = (_props) => {
  const classes = useStyles();
  const { preorderId } = useParams();

  const [preorder, setPreorder] = useState();
  const [loading, setLoading] = useState(true);

  const getPreorder = useCallback(() => {
    setLoading(true);
    const request = {
      params: {
        completed: true,
      },
    };

    httpGetPreorder(request, preorderId).then((response) => {
      setPreorder(response);
      setLoading(false);
    });
  }, [preorderId]);

  useEffect(() => {
    getPreorder();
  }, [preorderId, getPreorder]);

  return (
    <Paper className={classes.content} elevation={0} square>
      {loading ? (
        <SpinnerCentered />
      ) : (
        <OrderDetail order={preorder} tripType="preorder" />
      )}
    </Paper>
  );
};

export default PreorderDetailView;
